import { AddressSearch } from "@ts/components/AddressSearch";
import { AnimatedButton } from '@ts/components/AnimatedButton';
import { Modal } from '@ts/components/Modal';
import IMask from 'imask';
import { validateFields } from "@js/_global/validation";
let saveEarningsBtn, token;

const checkoutAPIEndpoints = {
    validateAddress: null
}

export const init = () => {
    setHTMXListeners();
    setInteractiveElements();
};

const setInteractiveElements = () => {
    setSaveButton();
    setPaymentAddress();
    setAddressSearch();
    setModalTools();
    setAddressSearchTools();
    setZipCodeMask();
}

const setZipCodeMask = () => {
    const zipCodeInput = document.querySelector('.address-fields .zip input[type="text"]');
    if (zipCodeInput) {
        IMask(
            zipCodeInput, {
                mask: '00000[-0000]'
            }
        )
    }
}   

const setSaveButton = () => {
    [saveEarningsBtn] = AnimatedButton.create('#save-earnings-btn', {
        onClick: handleSaveEarningsClick
    }) || [];
};

const setHTMXListeners = () => {
    document.body.addEventListener('htmx:afterSettle', (event) => setInteractiveElements());
    document.body.addEventListener('htmx:historyRestore', () => setInteractiveElements());
}

const handleBtnErrorState = (btn) => {
    btn.setState('error', 1500, function() {
       btn.setState('default');
    });
} 

const handleSaveEarningsClick = async (e, btn) => {
    e.preventDefault();
    const button = btn.button; 
    const form = button.closest('form');
    const validationAddress = button.getAttribute('data-validate-address-url');
    const isValidForm = validateFields(button.closest('form'));

    if (!isValidForm) {
        handleBtnErrorState(btn);
        return false;
    };
    if (!validationAddress || !button.classList.contains('validate-address')) {
        form.requestSubmit();
        return;
    };

    const shippingAddressData = getShippingAddressData(form);
    const validationResult = await validateShippingAddress(form, shippingAddressData);

    if (!validationResult?.isValid) {
        createInvalidAddressModal(validationResult);
        return;
    }
    applyValidationDataToForm(form, validationResult);
    form.requestSubmit();
}

const createInvalidAddressModal = (validationData) => {
    const { addressLine1, addressLine2, city, state, zipCode } = validationData;
    const invalidAddressModal = document.getElementById('invalid-address-modal');
    if (!invalidAddressModal) return;
    invalidAddressModal.querySelector('.address-1').innerHTML = addressLine1;
    invalidAddressModal.querySelector('.address-2').innerHTML = addressLine2;
    invalidAddressModal.querySelector('.city').innerHTML = city;
    invalidAddressModal.querySelector('.state').innerHTML = state;
    invalidAddressModal.querySelector('.zip-code').innerHTML = zipCode;
    
    const modalTitle = invalidAddressModal?.dataset.modalTitle;
    Modal.create('#invalid-address-modal', {
        modalTitle: modalTitle ?? 'Invalid Address',
        modalSize: 'modal-sm'
    });
}

const setModalTools = () => {
    const invalidAddressModal = document.getElementById('invalid-address-modal');
    if (!invalidAddressModal) return;

    const confirmAddressBtn = invalidAddressModal.querySelector('.confirm-address');
    const reEnterAddressBtn = invalidAddressModal.querySelector('.re-enter-address');

    if (confirmAddressBtn) {
        confirmAddressBtn.addEventListener('click', () => {
            const form = document.querySelector('#payout-form form');
            if (form) {
                form.querySelector('#InvalidAddressOverride').value = "true";
                form.requestSubmit();
                Modal.closeAllModals();
            }
        });
    }

    if (reEnterAddressBtn) {
        reEnterAddressBtn.addEventListener('click', () => {
           Modal.closeAllModals();
        });
    } 
}

const getShippingAddressData = (form) => {
    const addressData = {};
    addressData.AddressLine1 = form.querySelector('.address-fields .address1 input[type="text"]')?.value;
    addressData.AddressLine2 = form.querySelector('.address-fields .address2 input[type="text"]')?.value;
    addressData.City = form.querySelector('.address-fields .city input[type="text"]')?.value;
    addressData.State = form.querySelector('.address-fields .state select')?.value;
    addressData.ZipCode = form.querySelector('.address-fields .zip input[type="text"]')?.value;
    return addressData;
}

const resetShippingAddressFields = (form) => {
    const addressFields = form.querySelector('.address-fields');
    if (!addressFields) return;
    addressFields.querySelectorAll('input, select').forEach((field) => {
        const errorIndicator = field.nextElementSibling;
        if (!errorIndicator) return;
        errorIndicator.classList.remove("field-validation-error");
        errorIndicator.classList.add("field-validation-valid");
        errorIndicator.textContent = "";
    });
}

const handleValidationFailures = (errorData) => {
    const {title, status, errors} = errorData;
    const addressFields = document.querySelector('.address-fields');
    if (!addressFields) return;
    errors.forEach((error) => {
        const fieldName = error.name.charAt(0).toUpperCase() + error.name.slice(1);
        const fieldError = error.reason
        const field = addressFields.querySelector(`[name="${fieldName}"]`);

        if (field) {
            const errorIndicator = field.nextElementSibling;
            errorIndicator.classList.remove("field-validation-valid");
            errorIndicator.classList.add("field-validation-error");
            errorIndicator.textContent = fieldError;
        }
    });
}

const validateShippingAddress = async (form, addressData) => {
    const token = getToken(form);
    resetShippingAddressFields(form);
    const validationData = await AddressSearch.validateAddress(
        checkoutAPIEndpoints.validateAddress, 
        token,
        addressData,
        {
            onFail: async (errorData) => {
                handleValidationFailures(errorData);
            }
        });

        if (!validationData.isValid) {
            handleShippingVerificationIssues(validationData);
            return;
        }   
        applyValidationDataToForm(form, validationData);
    return validationData;
}   

const handleShippingVerificationIssues = (validationData) => {
    if(!validationData) return;
    const { addressLine1, addressLine2, city, state, zipCode } = validationData;
    const invalidAddressModal = document.getElementById('invalid-address-modal');
    if (!invalidAddressModal) return;
    invalidAddressModal.querySelector('.address-1').innerHTML = addressLine1;
    invalidAddressModal.querySelector('.address-2').innerHTML = addressLine2;
    invalidAddressModal.querySelector('.city').innerHTML = city;
    invalidAddressModal.querySelector('.state').innerHTML = state;
    invalidAddressModal.querySelector('.zip-code').innerHTML = zipCode;
    
    const modalTitle = invalidAddressModal?.dataset.modalTitle;

    Modal.create('#invalid-address-modal', {
        modalTitle: modalTitle ?? 'Attention',
        modalSize: 'modal-md'
    });
}  

const applyValidationDataToForm = (form, validationData) => {
    const address1 = form.querySelector('.address-fields .address1 input[type="text"]').value = validationData.addressLine1;
    const address2 = form.querySelector('.address-fields .address2 input[type="text"]').value = validationData.addressLine2;
    const city = form.querySelector('.address-fields .city input[type="text"]').value = validationData.city;
    const state = form.querySelector('.address-fields .state select').value = validationData.state;
    const zip = form.querySelector('.address-fields .zip input[type="text"]').value = validationData.zipCode;
};

const setAddressSearchRequired = (container, isRequired) => {
    const addressSearchRequiredField = container.querySelector(".address-search-required");
    if (!addressSearchRequiredField) return;
    addressSearchRequiredField.value = isRequired ? "True" : "False";
}

const handleAddressSearchOpen = (searchInput) => {
    const shippingAddressContainer = searchInput.closest(".shipping-address-container");
    if (!shippingAddressContainer) return;

    shippingAddressContainer.setAttribute("data-view-mode", "searching");

    const addressSuggestionRequired =
        shippingAddressContainer.querySelector(".address-search-required");
    if (addressSuggestionRequired && "value" in addressSuggestionRequired) {
        addressSuggestionRequired.value = "False";
    }
}

const handleAddressSelect = async (data, searchInput) => {
    const { address1, address2, city, state, zip } = data;
    const shippingAddressContainer = searchInput.closest(".shipping-address-container");
    if (!shippingAddressContainer) return;
    const form = shippingAddressContainer.closest("form");
    if (!form) return;

    shippingAddressContainer.setAttribute("data-view-mode", "found");

    const addressLine1 = shippingAddressContainer.querySelector(".address1 input[type='text']");
    const addressLine2 = shippingAddressContainer.querySelector(".address2 input[type='text']");
    const cityInput    = shippingAddressContainer.querySelector(".city input[type='text']");
    const stateSelect  = shippingAddressContainer.querySelector(".state select");
    const zipInput     = shippingAddressContainer.querySelector(".zip input[type='text']");
    
    if (addressLine1) addressLine1.value = address1;
    if (addressLine2) addressLine2.value = address2;
    if (cityInput)    cityInput.value    = city;
    if (stateSelect)  stateSelect.value  = state;
    if (zipInput)     zipInput.value     = zip;     
    
    setAddressSearchRequired(shippingAddressContainer, false);
    const button = document.querySelector('.payout-address-edit #save-earnings-btn');
    if (button)button.classList.add('validate-address');
}

const getToken = (form) => {
    if (token) return token;
    const tokenField = form.querySelector('input[name="__RequestVerificationToken"]');
    token = tokenField ? tokenField.value : null;
    return token;
}  

const setAddressSearch = () => {
    const [addressSearch] = AddressSearch.create("#payout-form .address-autocomplete", {
        apiKey: "195948433105312307",
        submitButtonSelector: "#save-earnings-btn",
        lookupAddressUrl: "https://us-autocomplete-pro.api.smarty.com/lookup?",
        suggestionDelay: 300
    }) || [];

    if (!addressSearch) {
        return;
    }

    addressSearch.onOpen(searchInput => handleAddressSearchOpen(searchInput));
    addressSearch.onSelect((data, searchInput) => handleAddressSelect(data, searchInput));
};

const setAddressSearchTools = () => {
    
    const checkoutBtn = document.getElementById('save-earnings-btn');
    if (!checkoutBtn) return;
    const payoutForm = document.getElementById('payout-form');
    if (!payoutForm) return;
    
    // Set API endpoints from data attributes
    checkoutAPIEndpoints.validateAddress = checkoutBtn.getAttribute('data-validate-address-url');

    // Address Search Listeners
    payoutForm.addEventListener("click", (e) => {

        const target = e.target;
        if (!(target instanceof HTMLElement)) return;
        const button = document.querySelector('.payout-address-edit #save-earnings-btn');
        const findAnotherLink = target.closest(".find-another-address a");
        if (findAnotherLink) {
            e.preventDefault();
            const shippingAddressContainer = findAnotherLink.closest(".shipping-address-container");
            if (!shippingAddressContainer) return;

            clearFields(shippingAddressContainer);
            shippingAddressContainer.setAttribute("data-view-mode", "search");
            if (button)button.classList.remove('validate-address');

            setAddressSearchRequired(shippingAddressContainer, true);

            return;
        }

        const dontSeeLink = target.closest(".dont-see-address a");
        if (dontSeeLink) {
            e.preventDefault();
            const shippingAddressContainer = dontSeeLink.closest(".shipping-address-container");
            if (!shippingAddressContainer) return;
            clearFields(shippingAddressContainer);
            if (button) button.classList.add('validate-address');
            shippingAddressContainer.setAttribute("data-view-mode", "found");
            setAddressSearchRequired(shippingAddressContainer, false);
        }
    });
}

const setPaymentAddress = (container, data) => {
    //edit-address
    const savedAddress = document.querySelector('.saved-address');
    if (savedAddress) {
        const editAddress = savedAddress.querySelector('.edit-address');
        editAddress.addEventListener('click', (e) => {
            e.preventDefault();
            const payoutContainer = editAddress.closest(".payout-container");
            if (!payoutContainer) return;
            payoutContainer.setAttribute("data-view-mode", "edit");
        });
    }
}

const clearFields = (container) => {
    const inputs = container.querySelectorAll("input[type='text']");
    inputs.forEach(input => { input.value = ""; });

    const suggestions = container.querySelector(".address-suggestions");
    if (suggestions) {
        suggestions.innerHTML = "";
        suggestions.style.display = "none";
    }
}